import styled from 'styled-components';
import { palette } from 'styled-theme';

const SaleWidgetWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;
  border-top-color: coral;
  // border: 1px solid ${palette('border', 2)};
  .wrapper{
    padding: 30px;
  }
  .top{
    position: absolute;
    width:100%;
    height: 4px;
    background-color: ${props => props.top ? props.top : '#725CA4'};
  }
  .isoSaleLabel {
   
    font-weight: 700;
    line-height: 1.2;
    text-transform: uppercase;
    color: ${palette('text', 0)};
    margin: 0 0 20px;
  }

  .isoSalePrice {
    // font-family: 'Roboto';
    font-size: 50px;
    font-weight: 300;
    line-height: 1.2;
    margin: 0 0 20px;
  }

  .isoSaleDetails {
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    color: ${palette('text', 2)};
    margin: 0;
  }
`;

export { SaleWidgetWrapper };



// WEBPACK FOOTER //
// ./src/containers/Dashboard/sale/style.js